import { AuthService } from './auth.service'
import {inject} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Observable, switchMap, take} from 'rxjs';
import {ROUTES} from '../../../routes.enum';

export function authAppInitializerFactory(authService: AuthService): () => Observable<void> {
  const activatedRoute =  inject(ActivatedRoute);
  return () => activatedRoute.url
    .pipe(
      take(1),
      switchMap(url => {
        if (!window.location.pathname.includes(ROUTES.REGISTER) &&
            !window.location.pathname.includes(ROUTES.DOCUMENTS)) {
          return authService.runInitialLoginSequence();
        }
        return Promise.resolve();
      }),
    )
  ;
}
